// lockout.ts
// Service functions for interacting with lockout APIs.
// Provides retrieval, creation, and deletion operations for case lockouts.

import { tokenAxios } from "@/utils/axios";
import { Lockout, GetLockoutArgs } from "@/types/lockout";

/**
 * Fetches lockout information for a given case.
 * @param params - Parameters including practiceId and caseId
 * @returns The lockout object or empty string if not locked
 */
export const getLockout = async (params: GetLockoutArgs) => {
  const { data } = await tokenAxios().get<Lockout | "">(`/api/lockout/${params.practiceId}/${params.caseId}`, {
    params,
  });
  return data;
};

/**
 * Creates a lockout for a given case.
 * @param params - Parameters including practiceId and caseId
 * @returns The created lockout object
 */
export const postLockout = async (params: GetLockoutArgs) => {
  const { data } = await tokenAxios().post<Lockout>(`/api/lockout/${params.practiceId}/${params.caseId}`, params, {
    params,
  });
  return data;
};

/**
 * Deletes a lockout for a given case.
 * @param params - Parameters including practiceId and caseId
 * @returns The deleted lockout object
 */
export const deleteLockout = async (params: GetLockoutArgs) => {
  const { data } = await tokenAxios().delete<Lockout>(`/api/lockout/${params.practiceId}/${params.caseId}`, {
    params,
  });
  return data;
};
